import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import ClientLayout from '@/pages/ClientLayout.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: ClientLayout,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/pages/Dashboard.vue'),
      },
      {
        path: 'send-sms',
        name: 'sendSms',
        component: () => import('@/pages/SendSms.vue'),
      },
      {
        path: 'realtime-progress',
        name: 'realTimeProgress',
        component: () => import('@/pages/RealTimeProgress.vue'),
      },
      {
        path: 'pending-queue',
        name: 'pendingQueue',
        component: () => import('@/pages/PendingQueue.vue'),
      },
      {
        path: 'sms-search',
        name: 'smsSearch',
        component: () => import('@/pages/SmsSearch.vue'),
      },
      {
        path: 'export-records',
        name: 'exportRecords',
        component: () => import('@/pages/ExportRecords.vue'),
      },
      {
        path: 'api-docs',
        name: 'apiDocs',
        component: () => import('@/pages/ApiDocumentation.vue'),
      },
      {
        path: 'api-keys',
        name: 'apiKeys',
        component: () => import('@/pages/ApiKeysConfig.vue'),
      },
      {
        path: 'platform-settings',
        name: 'platformSettings',
        component: () => import('@/pages/PlatformSettings.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  if (to.meta.public) {
    next()
    return
  }
  if (!getToken()) {
    next('/login')
    return
  }
  next()
})

export default router
